module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-3-df1b4c0be7a5ba32b7ea5d77e66f13cf.svg";